export default __webpack_public_path__ + "static/lock-6d53b7c6253037480175488a5277df9a.png";